<template>
  <div>
    <transition name="fade">
      <div v-if="loading">
        <div class="grid sm:grid-cols-4  grid-cols-2 p-5 gap-5">
          <div v-for="item in 4" :key="item" class="h-32 placeholderLoader rounded-lg"></div>
        </div>
      </div>
      <div v-else class="grid sm:grid-cols-3 md:grid-cols-6  grid-cols-2 p-5 gap-2">
        <div v-for="(tab, index) in tabs" :key="index">
          <!-- <router-link :key="tab.route" :to="tab.route"> -->
          <div @click="goToPage(tab.name)" class="rounded-lg p-4 gradient text-white h-36 flex flex-col justify-between">
            <div class="flex justify-between flex-wrap gap-1 items-start">
              <p class="text-sm font-semibold">
                {{ tab.name }}
              </p>
              <p class="
                  text-sm
                  bg-white
                  text-black
                  p-0.5
                  font-semibold
                  rounded
                  opacity-50
                ">
                {{ tab.desc }}
              </p>
            </div>
            <div class="flex justify-between flex-wrap items-end">
              <div class="min-w-0">
                <span class="text-sm block text-left">{{ tab.nameType }}</span>
                <p class="text-sm font-medium text-left truncate">
                  {{ Number(tab.number).toLocaleString() }}
                </p>
              </div>
              <div class="h-9 w-9 rounded-full bg-white p-3 opacity-80 shadow-lg flex items-center justify-center">
                <img class="h-full w-full object-contain" :src="tab.icon" />
              </div>
            </div>
          </div>
          <!-- </router-link> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "Analytics",
  data() {
    return {
      loading: false,
      tabs: [
        {
          name: "Mpesa Revenue",
          desc: "Total",
          icon: require("@/assets/icons/dollar.png"),
          nameType: "KES",
          number: null,
          route: ''
        },
        {
          name: "Mpesa Transactions",
          desc: "Total",
          icon: require("@/assets/icons/chart.png"),
          nameType: "Count",
          number: null,
          route: '#Transactions'
        },
        {
          name: "I&M Revenue",
          desc: "Total",
          icon: require("@/assets/icons/dollar.png"),
          nameType: "KES",
          number: null,
          route: ''
        },

        {
          name: "I&M Transactions",
          desc: "Total",
          icon: require("@/assets/icons/chart.png"),
          nameType: "Count",
          number: null,
          route: '#I&M Transactions'
        },

        {
          name: "Shortcodes",
          desc: "Total",
          icon: require("@/assets/icons/receipt.png"),
          nameType: "Count",
          number: null,
          route: '#Shortcodes'
        },
        {
          name: "Users",
          desc: "Total",
          icon: require("@/assets/icons/user-w.png"),
          nameType: "Count",
          number: null,
          route: '#Users'
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {
    this.loading = true;
    const options = {
      headers: {
        Authorization: `Bearer ${this.getToken}`,
      },
    };
    axios.get(`${this.$route.params.organization}/dashboard/info`, options).then(
      (response) => {
        const d = response.data.Data || response.data;
        this.tabs[0].number = d.revenue;
        this.tabs[1].number = d.transactions;
        this.tabs[2].number = d.imRevenue;
        this.tabs[3].number = d.imTransactions;
        this.tabs[4].number = d.shortcodes;
        this.tabs[5].number = d.users;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  },
  methods: {
    goToPage(name) {
      switch (name) {
        case "Transactions":
          break;

        default:
          break;
      }
    },

  },
};
</script>

<style scoped>
.gradient {
  /* darker grey gradient for dashboard cards */
  background: #3a3a3a;
  background: -moz-linear-gradient(90deg, #4a4a4a 0%, #2a2a2a 100%);
  background: -webkit-linear-gradient(90deg, #4a4a4a 0%, #2a2a2a 100%);
  background: linear-gradient(90deg, #4a4a4a 0%, #2a2a2a 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#4a4a4a", endColorstr="#2a2a2a", GradientType=1);
}
</style>
